export default __webpack_public_path__ + "static/media/ssc-home.0d2dae0a.png";